import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import './FamilyActionModal.css';

const FamilyActionModal = ({ 
    show, 
    onHide, 
    rowData, 
    onApprove, 
    onReject, 
    isProcessing = false 
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            centered
            className="family-action-modal"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="modal-header">
                <Modal.Title>Action</Modal.Title>
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={onHide}
                >
                    <span aria-hidden="true">
                        <FaTimes />
                    </span>
                </button>
            </Modal.Header>
            
            <Modal.Body className="card-height">
                <div className="row d-flex justify-content-center align-items-center">
                    <h4 className="col-12 d-flex justify-content-center align-items-center">
                        <span>
                            <span className="text-info">
                                {rowData && rowData.relative_name}
                            </span>
                            <span> has requested to add you as a </span>
                            <span className="text-info">
                                {rowData && rowData.relation_type_name}
                            </span>
                        </span>
                    </h4>
                    <span className="col-12 d-flex justify-content-center align-items-center">
                        By approving this request, you acknowledge that, they can view or manage your personal data and vice-versa.
                    </span>
                </div>
            </Modal.Body>
            
            <Modal.Footer className="justify-content-center">
                <Button
                    variant="success"
                    onClick={onApprove}
                    disabled={isProcessing}
                >
                    {isProcessing ? 'Processing...' : 'Approve'}
                </Button>
                <Button
                    variant="danger"
                    onClick={onReject}
                    disabled={isProcessing}
                >
                    {isProcessing ? 'Processing...' : 'Reject'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FamilyActionModal; 